import { PaletteMode, PaletteOptions } from '@mui/material';

import { colors } from './colors';

const defaultBaseColors = {
  primary: {
    700: colors.primary_30,
    500: colors.primary_40,
    100: colors.primary_80,
  },
  secondary: {
    700: colors.neutral_20,
    500: colors.neutral_30,
    100: colors.primary_80,
  },
  tertiary: {},
  neutral: {
    700: colors.neutral_20,
    500: colors.neutral_30,

    100: colors.neutral_60,
  },
  gradient: {
    500: colors.gradient_40,
  },
  success: {
    500: colors.green_50,
  },
  warning: {
    500: colors.warning_50,
  },
  error: {
    700: colors.error_30,
    500: colors.error_40,
    100: colors.error_80,
  },
};

const customColors = {
  primary_20: colors.primary_20,
  primary_30: colors.primary_30,
  primary_40: colors.primary_40,
  primary_45: colors.primary_45,
  primary_50: colors.primary_50,
  primary_60: colors.primary_60,
  primary_70: colors.primary_70,
  primary_80: colors.primary_80,
  primary_90: colors.primary_90,

  secondary_40: colors.secondary_40,
  secondary_80: colors.secondary_80,

  gradient_20: colors.gradient_20,
  gradient_40: colors.gradient_40,
  gradient_60: colors.gradient_60,
  gradient_80: colors.gradient_80,

  error_20: colors.error_20,
  error_30: colors.error_30,
  error_40: colors.error_40,
  error_45: colors.error_45,
  error_50: colors.error_50,
  error_60: colors.error_60,
  error_80: colors.error_80,

  neutral_20: colors.neutral_20,
  neutral_30: colors.neutral_30,
  neutral_40: colors.neutral_40,
  neutral_60: colors.neutral_60,
  neutral_80: colors.neutral_80,
  neutral_90: colors.neutral_90,

  warning_40: colors.warning_40,
  warning_50: colors.warning_50,
  warning_60: colors.warning_60,
  warning_80: colors.warning_80,
  warning_90: colors.warning_90,

  red_80: colors.red_80,

  green_30: colors.green_30,
  green_50: colors.green_50,
  green_70: colors.green_70,
  green_80: colors.green_80,
  green_90: colors.green_90,

  accent_40: colors.accent_40,

  highlight_40: colors.highlight_40,
  highlight_50: colors.highlight_50,

  yellow_20: colors.yellow_20,
  yellow_30: colors.yellow_30,
  yellow_40: colors.yellow_40,
  yellow_50: colors.yellow_50,
  yellow_60: colors.yellow_60,
};

export const getPalette = (
  mode: PaletteMode,
): PaletteOptions & {
  common: Record<string, string>;
  secondary: Record<string, string>;
  primary: Record<string, string>;
  error: Record<string, string>;
  gradient: Record<string, string>;
} => ({
  ...(mode === 'light'
    ? {
        common: {
          black: colors.black,
          white: colors.white,
        },
        mode: 'light',
        background: {
          paper: colors.white,
        },
        primary: {
          main: colors.primary_40,
          ...defaultBaseColors.primary,
        },
        secondary: {
          main: colors.neutral_40,
          ...defaultBaseColors.secondary,
        },
        gradient: {
          main: colors.gradient_40,
          ...defaultBaseColors.gradient,
        },
        tertiary: {
          ...defaultBaseColors.tertiary,
        },
        neutral: {
          main: colors.neutral_40,
          ...defaultBaseColors.neutral,
        },
        success: {
          main: colors.green_50,
          ...defaultBaseColors.success,
        },
        warning: {
          main: colors.warning_50,
          ...defaultBaseColors.warning,
        },
        error: {
          main: colors.error_40,
          ...defaultBaseColors.error,
        },
        surface: {
          main: colors.white,
        },
        custom: {
          ...customColors,
        },
      }
    : {
        common: {
          black: colors.white,
          white: colors.black,
        },
        mode: 'dark',
        background: {
          paper: colors.black,
        },
        primary: {
          main: colors.primary_40,
          ...defaultBaseColors.primary,
        },
        secondary: {
          main: colors.neutral_40,
          ...defaultBaseColors.secondary,
        },
        gradient: {
          main: colors.gradient_40,
          ...defaultBaseColors.gradient,
        },
        tertiary: {
          ...defaultBaseColors.tertiary,
        },
        neutral: {
          main: colors.neutral_40,
          ...defaultBaseColors.neutral,
        },
        success: {
          main: colors.green_50,
          ...defaultBaseColors.success,
        },
        warning: {
          main: colors.warning_50,
          ...defaultBaseColors.warning,
        },
        error: {
          main: colors.error_30,
          ...defaultBaseColors.error,
        },
        surface: {
          main: colors.black,
        },
        custom: {
          ...customColors,
        },
      }),
});
